import PropTypes from 'prop-types';
import styles from './TabList.module.scss';

const TabList = ({ children, ...props }) => {
    return (
        <ul { ...props } className={styles.list} role="tablist">
            {children}
        </ul>
    );
};

TabList.propTypes = {
    children: PropTypes.any
};

export default TabList;
